import React from "react";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import Flow from "../components/Flow";
import { EmailStep, NamePhoneCodeStep, CompanyStep } from "../steps";

const DefaultFlow = ({ t, onComplete, ...props }) => (
	<Flow onComplete={onComplete} {...props} title={t("defaultFlowTitle")}>
		<EmailStep />
		<NamePhoneCodeStep />
		<CompanyStep />
	</Flow>
);

DefaultFlow.propTypes = {
	onComplete: PropTypes.func.isRequired,
};

export default translate()(DefaultFlow);



// WEBPACK FOOTER //
// ./src/flows/default.js